export const lightTheme = {
  colors: {
    body: '#E2E2E2',
    primary: '#5C67CA',

    secondary: '#77787C',
    danger: '#F6392D',
    white: '#FFFFFF',
    success: '',
    cyan: '#74E1CF',
    gray: '#818A8E',
    darkGray: '#4e5c79',
    black: '#000000',
    inputbackground: '#EDEFF8',
    hover: '#EDEFF8',
    background: '#Fafafa',
  },
  fontSize: {
    h1: '32px',
    h2: '28px',
    h3: '24px',
    h4: '22px',
    h5: '18px',
    h6: '14px',
    para12: '12px',
    para14: '14px',
    para16: '16px',
    para18: '18px',
  },
  borderRadius: {
    border4: '4px',
    border8: '8px',
    border16: '16px',
    border32: '32px',
    borderRound: '50px',
  },
  input: {
    padding: '9px 16px',
    paddingBig: '12px 16px',
    paddingSmall: '8px 16px',
  },
  button: {
    shadow: 'rgba(115, 205, 190, 0.25)',
    border: 'rgba(255, 255, 255, 0.18)',
    background: '#74E1CF',
    backgroundHover: '#81FAE6',
    color: '#000000',
  },
  sidebar: {
    activeText: '#FFFFFF',
    text: '#818A8E',
  },
  home: {
    background: 'rgba(37, 39, 40, 0.6)',
    border: 'rgba(139, 139, 139, 0.4)',
    popular: {
      color: '#818A8E',
    },
    cyan: '#74E1CF',
  },
}

export const darkTheme = {
  colors: {
    body: '#E2E2E2',
    primary: '#73CDBE',
    danger: '#F6392D',
    white: '#FFFFFF',
    cyan: '#74E1CF',
    gray: '#818A8E',
    black: '#000000',
  },
}
